import { SynthOptions } from "tone";
import { RydInstrument } from "../../../model/instrument";
import React, { JSX } from "react";
import { ThreeVoiceSynthSurface } from "./3VoiceSynth";
import { ThreeVoiceSynth } from "../../../audio/instruments/ThreeMonoSynth";
import TR808Drum from "../../../audio/instruments/TR808Drum";
import { TrAcht } from "./TrAcht";

export function mapToSynthSurface(instrument: RydInstrument) : JSX.Element {
    switch(instrument.id) {
        case '3 voice synth':
            return <ThreeVoiceSynthSurface synth={instrument as ThreeVoiceSynth<SynthOptions>} />;
        case 'TR808Drum':
            return <TrAcht drum={instrument as TR808Drum} />;
        default:
            return <div>Unsupported synth: {instrument.name} ({instrument.id})</div>;
    }

}